<template>
  <div class="mobile-core-offers">
    <!-- Hero Section -->
    <section class="relative h-64 bg-cover bg-center" :style="{ backgroundImage: `url(${bannerOffers})` }">
      <div class="absolute inset-0 bg-black bg-opacity-40"></div>
      <div class="relative z-10 h-full flex items-center px-4">
        <h1 class="text-white text-xl font-bold">
          {{ coreOffersTexts.hero?.title || 'Our Core Offers' }}
        </h1>
      </div>
    </section>

    <!-- Sourcing & Procurement Section -->
    <section class="px-4 py-6  w-full">
      <h2 class="text-lg font-bold text-gray-800 mb-3">
        {{ coreOffersTexts.sourcing?.title || 'Sourcing & Procurement from China' }}
      </h2>
      <p class="text-gray-600 text-sm leading-relaxed mb-4">
        {{ coreOffersTexts.sourcing?.description || '' }}
      </p>

      <!-- Features Grid -->
      <div class="grid grid-cols-3 gap-2 mb-4">
        <div class="text-center bg-white rounded-lg p-3 shadow-sm">
          <div class="w-10 h-10 mx-auto mb-2 bg-blue-100 rounded-full flex items-center justify-center">
            <img src="../assets/icn_offers_jp.png" alt="Qualification" class="w-6 h-6" />
          </div>
          <h3 class="text-xs font-semibold text-blue-900 mb-1 leading-tight">
            {{ coreOffersTexts.sourcing?.features?.qualification?.title || 'Supplier Qualification' }}
          </h3>
          <p class="text-xs text-gray-500 leading-tight">
            {{ coreOffersTexts.sourcing?.features?.qualification?.description || '' }}
          </p>
        </div>

        <div class="text-center bg-white rounded-lg p-3 shadow-sm">
          <div class="w-10 h-10 mx-auto mb-2 bg-blue-100 rounded-full flex items-center justify-center">
            <img src="../assets/icn_offers_cpo.png" alt="Optimization" class="w-6 h-6" />
          </div>
          <h3 class="text-xs font-semibold text-blue-900 mb-1 leading-tight">
            {{ coreOffersTexts.sourcing?.features?.optimization?.title || 'Cost Optimization' }}
          </h3>
          <p class="text-xs text-gray-500 leading-tight">
            {{ coreOffersTexts.sourcing?.features?.optimization?.description || '' }}
          </p>
        </div>

        <div class="text-center bg-white rounded-lg p-3 shadow-sm">
          <div class="w-10 h-10 mx-auto mb-2 bg-blue-100 rounded-full flex items-center justify-center">
            <img src="../assets/icn_offers_td.png" alt="Traceability" class="w-6 h-6" />
          </div>
          <h3 class="text-xs font-semibold text-blue-900 mb-1 leading-tight">
            {{ coreOffersTexts.sourcing?.features?.traceability?.title || 'Traceability' }}
          </h3>
          <p class="text-xs text-gray-500 leading-tight">
            {{ coreOffersTexts.sourcing?.features?.traceability?.description || '' }}
          </p>
        </div>
      </div>

      <!-- Sourcing Button -->
      <button 
        @click="goToSourceProduct"
        class="w-full bg-orange-500 text-white py-3 px-4 rounded-full font-semibold text-sm"
      >
        {{ coreOffersTexts.sourcing?.button?.title || 'Sourcing Illustrations' }} >
      </button>
    </section>

    <!-- Logistics Section -->
    <section class="px-4 py-6 bg-blue-900 text-white w-full">
      <h2 class="text-lg font-bold mb-3">
        {{ coreOffersTexts.logistics?.title || 'Logistics & Supply Chain Management' }}
      </h2>
      <p class="text-sm leading-relaxed mb-4 text-blue-100">
        {{ coreOffersTexts.logistics?.description || '' }}
      </p>

      <!-- Logistics Cards -->
      <div class="grid grid-cols-3 gap-2">
        <div v-for="(card, index) in logisticsCards" :key="index" class="relative">
          <img :src="card.img" :alt="card.alt" class="w-full h-60 object-cover rounded-lg" />
          <div class="absolute inset-0 bg-[rgba(169,107,0,0.7)] bg-opacity-80 rounded-lg flex flex-col justify-start items-start p-2 pt-4">
            <img :src="card.icon" class="w-6 h-6 mb-2" />
            <h3 class="text-xs font-bold text-left leading-tight mb-1">{{ card.title }}</h3>
            <p class="text-xs text-left opacity-90 leading-tight">{{ card.subTitle }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Sales Service Section -->
    <section class="px-4 py-6 bg-gray-50 w-full">
      <h2 class="text-lg font-bold text-gray-800 mb-3">
        {{ coreOffersTexts.salesService?.title || 'Sales Service' }}
      </h2>
      <p class="text-gray-600 text-sm leading-relaxed mb-4">
        {{ coreOffersTexts.salesService?.description || '' }}
      </p>

      <div class="space-y-4">
        <!-- Market Access - 图片在左，文字在右 -->
        <div class="flex items-center gap-3">
          <div class="w-1/2 aspect-square relative">
            <img :src="offerItems[0].img" :alt="offerItems[0].title" class="w-full h-full object-cover rounded-lg" />
            <div class="absolute inset-0 bg-black bg-opacity-40 rounded-lg flex items-center justify-center">
              <h3 class="font-bold text-white text-xs text-center leading-tight px-2">{{ offerItems[0].title }}</h3>
            </div>
          </div>
          <div class="w-1/2">
            <p class="text-gray-600 text-xs leading-relaxed">{{ offerItems[0].text }}</p>
          </div>
        </div>

        <!-- Trusted Presence - 文字在左，图片在右 -->
        <div class="flex items-center gap-3">
          <div class="w-1/2">
            <p class="text-gray-600 text-xs leading-relaxed">{{ offerItems[1].text }}</p>
          </div>
          <div class="w-1/2 aspect-square relative">
            <img :src="offerItems[1].img" :alt="offerItems[1].title" class="w-full h-full object-cover rounded-lg" />
            <div class="absolute inset-0 bg-black bg-opacity-40 rounded-lg flex items-center justify-center">
              <h3 class="font-bold text-white text-xs text-center leading-tight px-2">{{ offerItems[1].title }}</h3>
            </div>
          </div>
        </div>

        <!-- Results Growth - 图片在左，文字在右 -->
        <div class="flex items-center gap-3">
          <div class="w-1/2 aspect-square relative">
            <img :src="offerItems[2].img" :alt="offerItems[2].title" class="w-full h-full object-cover rounded-lg" />
            <div class="absolute inset-0 bg-black bg-opacity-40 rounded-lg flex items-center justify-center">
              <h3 class="font-bold text-white text-xs text-center leading-tight px-2">{{ offerItems[2].title }}</h3>
            </div>
          </div>
          <div class="w-1/2">
            <p class="text-gray-600 text-xs leading-relaxed">{{ offerItems[2].text }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Engineering Section -->
    <section class="px-4 py-6 bg-blue-900 text-white w-full"   >
      <h2 class="text-lg font-bold mb-3">
        {{ coreOffersTexts.engineering?.title || 'Engineering' }}
      </h2>
      <p class="text-sm leading-relaxed mb-4 text-blue-100">
        {{ coreOffersTexts.engineering?.description || '' }}
      </p>

      <div class="flex justify-between items-start mb-4 px-2" >
        <div class="text-center flex-1">
          <div class="h-28 flex items-center justify-center mb-2">
            <div class="w-22 h-22 relative">
              <img src="../assets/img_offers_x.png" alt="Full-Cycle" class="w-full h-full rounded-full object-cover" />
              <div class="absolute inset-0 flex items-center justify-center">
                <p class="text-xs font-bold text-center leading-tight px-1">
                  {{ coreOffersTexts.engineering?.features?.fullCycle?.title || 'Full-Cycle' }}
                </p>
              </div>
            </div>
          </div>
          <p class="text-xs text-blue-100 leading-tight">
            {{ coreOffersTexts.engineering?.features?.fullCycle?.description || '' }}
          </p>
        </div>

        <div class="text-center flex-1">
          <div class="h-28 flex items-center justify-center mb-2">
            <div class="w-28 h-28 relative">
              <img src="../assets/img_offers_d.png" alt="Local Cost" class="w-full h-full rounded-full object-cover" />
              <div class="absolute inset-0 flex items-center justify-center">
                <p class="text-xs font-bold text-center leading-tight px-1">
                  {{ coreOffersTexts.engineering?.features?.localCost?.title || 'Local Cost' }}
                </p>
              </div>
            </div>
          </div>
          <p class="text-xs text-blue-100 leading-tight">
            {{ coreOffersTexts.engineering?.features?.localCost?.description || '' }}
          </p>
        </div>

        <div class="text-center flex-1">
          <div class="h-28 flex items-center justify-center mb-2">
            <div class="w-22 h-22 relative">
              <img src="../assets/img_offers_x.png" alt="Feasible" class="w-full h-full rounded-full object-cover" />
              <div class="absolute inset-0 flex items-center justify-center">
                <p class="text-xs font-bold text-center leading-tight px-1">
                  {{ coreOffersTexts.engineering?.features?.feasible?.title || 'Feasible' }}
                </p>
              </div>
            </div>
          </div>
          <p class="text-xs text-blue-100 leading-tight">
            {{ coreOffersTexts.engineering?.features?.feasible?.description || '' }}
          </p>
        </div>
      </div>
    </section>

    <!-- After Market Section -->
    <section class="px-4 py-6 bg-gray-50 w-full">
      <h2 class="text-lg font-bold text-gray-800 mb-3">
        {{ coreOffersTexts.afterMarket?.title || 'After Market Services' }}
      </h2>
      <p class="text-gray-600 text-sm leading-relaxed mb-4">
        {{ coreOffersTexts.afterMarket?.description || '' }}
      </p>

      <div class="mb-4">
        <img src="../assets/people.png" alt="After Market Service" class="w-full object-cover rounded-lg" style="aspect-ratio: 938 / 907;" />
      </div>

      <div class="space-y-3">
        <div v-for="(item, index) in contentList" :key="index" class="bg-white rounded-lg p-3 shadow-sm">
          <h3 class="font-bold text-blue-900 text-sm mb-1">{{ item.title }}</h3>
          <p class="text-gray-600 text-xs leading-relaxed">{{ item.description }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { computed, onMounted } from "vue";
import { useI18n } from 'vue-i18n';
import { pushToDataLayer } from '../utils/gtm';
import { useChatWidget } from '../utils/chatWidget';
import bannerOffers from "../assets/banner_offers.jpg";
import imgMae from "@/assets/img_offers_mae.png";
import imgTlp from "@/assets/img_offers_tlp.png";
import imgRdg from "@/assets/img_offers_rdg.png";
import { cards } from "../utils/imageData";
import bg_offer3 from "../assets/bg_offers_3.jpg";

const { locale, messages } = useI18n();
const router = useRouter();

// 获取核心服务文本
const coreOffersTexts = computed(() => {
  return messages.value[locale.value]?.coreOffers || {};
});

// 获取国际化的数据
const offerItems = computed(() => {
  const salesService = coreOffersTexts.value.salesService?.items || {};
  return [
    {
      title: salesService.marketAccess?.title || 'Market Access',
      text: salesService.marketAccess?.text || '',
      img: imgMae,
    },
    {
      title: salesService.trustedPresence?.title || 'Trusted Presence',
      text: salesService.trustedPresence?.text || '',
      img: imgTlp,
    },
    {
      title: salesService.resultsGrowth?.title || 'Results Growth',
      text: salesService.resultsGrowth?.text || '',
      img: imgRdg,
    },
  ];
});

const contentList = computed(() => {
  const afterMarket = coreOffersTexts.value.afterMarket?.services || {};
  return [
    {
      title: afterMarket.rapidResponse?.title || 'Rapid Response',
      description: afterMarket.rapidResponse?.description || '',
    },
    {
      title: afterMarket.lifecycleValue?.title || 'Lifecycle Value',
      description: afterMarket.lifecycleValue?.description || '',
    },
    {
      title: afterMarket.seamlessSupport?.title || 'Seamless Support',
      description: afterMarket.seamlessSupport?.description || '',
    },
  ];
});

// 添加调试
onMounted(() => {
  console.log('🔍 Logistics Cards Debug:');
  console.log('cards array:', cards);
  console.log('cards length:', cards.length);
  console.log('logisticsCards computed:', logisticsCards.value);
  console.log('coreOffersTexts.logistics:', coreOffersTexts.value.logistics);
});

// 获取国际化的物流卡片数据
const logisticsCards = computed(() => {
  const logisticsData = coreOffersTexts.value.logistics?.cards || {};
  console.log('logisticsData:', logisticsData);
  
  const result = [
    {
      img: cards[0]?.img,
      icon: cards[0]?.icon,
      title: logisticsData.endToEnd?.title || 'End-to-End Control',
      subTitle: logisticsData.endToEnd?.subtitle || '',
      alt: cards[0]?.alt,
    },
    {
      img: cards[1]?.img,
      icon: cards[1]?.icon,
      title: logisticsData.integrated?.title || 'Integrated Service Model',
      subTitle: logisticsData.integrated?.subtitle || '',
      alt: cards[1]?.alt,
    },
    {
      img: cards[2]?.img,
      icon: cards[2]?.icon,
      title: logisticsData.tailored?.title || 'Tailored Solutions',
      subTitle: logisticsData.tailored?.subtitle || '',
      alt: cards[2]?.alt,
    },
  ];
  
  console.log('computed result:', result);
  return result;
});

const { openChat } = useChatWidget();

const goToContactUs = () => {
  openChat("MobileCoreOffers");
  pushToDataLayer("Chat_With_Us", {
    category: "MobileCoreOffers",
    label: "Chat With Us",
  });
};

function goToSourceProduct() {
  router.push("/core-offers/source-product");
  pushToDataLayer("click", {
    category: "MobileCoreOffers",
    label: "goToSourceProduct",
  });
}
</script>

<style scoped>
.mobile-core-offers {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
</style>
